import { theme, styled } from 'ui/theme';

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${theme.space[2]};

  &[data-orientation='vertical'] {
    flex-flow: column;

    &[data-align='center'] {
      align-items: center;
    }

    &[data-align='end'] {
      align-items: end;
    }

    &[data-align='start'] {
      align-items: start;
    }
  }

  &[data-orientation='horizontal'] {
    &[data-align='center'] {
      justify-content: center;
    }

    &[data-align='end'] {
      justify-content: end;
    }

    &[data-align='start'] {
      justify-content: start;
    }
  }
`;
